import React from 'react';
const CTASection = () => {
  return <section id="contact" className="w-full py-24 bg-gradient-to-b from-navy-900 to-navy-800 observer-element" data-id="element-68">
      <div className="container mx-auto px-4 text-center" data-id="element-69">
        <div className="max-w-4xl mx-auto p-12 rounded-2xl bg-white shadow-xl border border-navy-100" data-id="element-70">
          <h2 className="text-4xl font-bold mb-6 fade-in text-gray-800" data-id="element-71">
            Ready to Build Your{' '}
            <span className="text-gradient" data-id="element-72">Financial Legacy?</span>
          </h2>
          <div className="elegant-divider my-8" data-id="element-73"></div>
          <p className="text-gray-700 max-w-3xl mx-auto mb-6 text-lg fade-in" data-id="element-74">
            Take the first step toward accelerated financial growth.
          </p>
          <p className="text-gray-700 max-w-3xl mx-auto mb-12 text-lg font-semibold fade-in italic" data-id="element-75">
            You don't need more motivation. You need your LEGACY in Motion.
          </p>
          <a href="https://link.builderspro.io/widget/form/Y62ZKJUTn6F3f3jyumwK" target="_blank" rel="noopener noreferrer" className="btn-legacy-navy inline-flex items-center justify-center" data-id="element-76">
            Let's Start Building
          </a>
          <div className="mt-8 text-sm text-gray-500 fade-in" data-id="element-77">
            No obligation. 100% confidential.
          </div>
        </div>
      </div>
    </section>;
};
export default CTASection;